import React, { useEffect, useRef } from 'react';
import { usePageVisibility } from 'react-page-visibility';
import useGame from '../hooks/useGame';
import backgroundMusic from '../assets/sound/loop_short.mp3';

const BackgroundAudio = () => {

  const isVisible = usePageVisibility();

  const { isPlayingBackgroundMusic, isListeningToAudio } = useGame();
  const audioPlayer = useRef();
  const audioVolumeMax = 0.3;
  const audioVolumeMin = 0.1;

  const isMobile = window.innerWidth < 769;

  let muted = false;

  if(!isVisible || !isPlayingBackgroundMusic){
    muted = true;
  }

  useEffect(() => {
    if (audioPlayer.current !== null) {
      if (isPlayingBackgroundMusic) {
        audioPlayer.current.play();
        audioPlayer.current.volume = audioVolumeMax;
      } else {
        audioPlayer.current.pause();
      }
    }
  }, [isPlayingBackgroundMusic]);

  useEffect(() => {
    if (audioPlayer.current !== null) {
      if (isListeningToAudio) {
        audioPlayer.current.volume = audioVolumeMin;

        if (isMobile) {
          audioPlayer.current.pause();
        }
      } else {
        audioPlayer.current.volume = audioVolumeMax;
        if (isMobile) {
          audioPlayer.current.play();
        }
      }
    }
  }, [isListeningToAudio]);

  return (
    <audio src={backgroundMusic} ref={audioPlayer} loop autoPlay={true} muted={muted} />
  );
};

export default BackgroundAudio;
